
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { Enums } from '../../../../models/common'
import { KingspanCreateEditController } from './kingspan-location-create-edit.constroller'
import { LOCATION_SERVICE_NAME, LocationService } from '../../../../services/location'
import { ACTION_SERVICE_NAME, ActionService } from '../../../../services/action'
import { METER_SERVICE_NAME, MeterService } from '../../../../services/meter'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../../services/device'
import { KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME, KingspanConfigurationFormService } from '../service'

//#region Asset Imports

import './kingspan-location-create-edit.scss'
import * as TEMPLATE from './kingspan-location-create-edit.tpl.html'

//#endregion

// Setup

export class KingspanCreateEditDirective
    implements ng.IDirective {

    restrict = 'E'

    controller: any = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        LOCATION_SERVICE_NAME,
        ACTION_SERVICE_NAME,
        METER_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSession: UserSessionService,
            locationService: LocationService,
            actionService: ActionService,
            meterService: MeterService,
            deviceService: DeviceService,
            kingspanService: KingspanConfigurationFormService
        ) => new KingspanCreateEditController(
            $scope,
            $q,
            $timeout,
            userSession,
            Enums.ReferenceType.IdLocation,
            Enums.SimaxModuleName.Location,
            locationService,
            actionService,
            meterService,
            deviceService,
            kingspanService
        )]

    template = TEMPLATE
}